import { Component, OnInit } from '@angular/core';
import { ChangeDataService } from 'src/app/Services/ChangeData/changeData.service';
import { delay } from 'rxjs/operators';
import { ApiService } from 'src/app/Services/Api/api.service';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.css'],
})
export class NoticiasComponent {
  public subcripcion?: Subscription;
  cardsData: any[] = [];

  dataHeader = {
    classTitle: 'blue',
    title: 'Noticias de interés',
    classSubtitle: 'small',
    subtitle: 'Entérate de lo que está pasando en Autovía Neiva - Girardot',
  };

  constructor(
    private changeDataService: ChangeDataService,
    private _apiService: ApiService
  ) {
    _apiService.get('noticia').then((data) => {
      this.cardsData = [
        ...data.noticias.map((noticia: any) => ({
          href: '/',
          src: `${environment.backendURL}/publico/imagenes/1/${noticia.imagen}`,
          altT: 'Card image cap',
          heightInput: '',
          widthInput: '',
          class: 'card-img-top noticia',
          date: noticia.fechaPublicacion,
          title: noticia.nombre,
          text: noticia.resumen,
          id: noticia.id,
        })),
      ];
    });
  }
}
